export const onboardingKeys = {
    all: ['onboarding'] as const,
    states: () => [...onboardingKeys.all, 'state'] as const,
    state: (organizationId: string) => [...onboardingKeys.states(), organizationId] as const,
    updateStateMutation: (organizationId: string | null) =>
        [...onboardingKeys.all, 'update-state', organizationId] as const
};
